module.exports = __webpack_public_path__ + "img/solution11.2ec62201.png";